



<div class="quick-cart" [ngClass]="{ 'cart-ltr' : lang == 'en' }">

  <!-- overlay -->
  <div class="overlay" [class.show-overlay]="showQuickCart" (click)="hideCart()"></div>

  <!-- cart body-->
  <div class="cart" [class.show-cart]="showQuickCart">

     <!-- cart products -->
     <div class="d-flex flex-column h-100 " >

        <!-- items -->
        <div  class="d-flex flex-column product-overview products-box py-3 ">

          <app-skelton *ngIf="isLoading"></app-skelton>

           <!-- single item -->
           <div *ngIf="!isLoading && !isNotFound">

               <div
               [@fadeOutAnimation]="cart_item.state"
               class="border-bottom desc mb-2 pb-2 gap-4"
               *ngFor="let cart_item of cart_list;let i = index"
               >


                  <div class="pro-img">
                     <div class="img-wrapper">

                        <div class="svg">
                           <!-- PLACE-HOLDER IMAGE HERE -->
                        </div>

                        <div class="lazyload-wrapper">
                              <div class="sc-a1431ab-2 jNGvqr">
                                 <img
                                 src="{{ cart_item?.product?.photo }}"
                                 [alt]="cart_item?.product?.description"
                                 class="sc-afe2674f-1 cfKlFZ quick-cart-product-img"
                                 width="85"
                                 >
                              </div>
                        </div>

                     </div>
                  </div>


                  <span class="pro-desc pt-0">

                     <p [innerHTML]="cart_item?.product?.brand?.name" class="cart-item-title text-truncate text-wrap text-muted"></p>
                     <p [innerHTML]="cart_item?.product?.name | app_product_name_pipe" class=" text-truncate text-wrap fw-normal fs-6"></p>

                     <div class="product-price mt-1" *ngIf="cart_item?.product?.offers?.length">
                        <span class="sc-5e739f1b-0 gEERDr wrapper d-flex align-items-center gap-3">
                              <div class="priceNow text-danger text-decoration-line-through" data-qa="div-price-now">
                                 <span>{{ currency }}</span>
                                 <span>{{  cart_item?.price | price_round }}</span>
                              </div>

                              <div class="text-success fw-bold fs-6">
                                 <span>{{ cart_item?.product?.offers[0]?.percentage }}</span>
                                 <span>%</span>
                              </div>
                        </span>
                     </div>

                     <div class="cart-item-title text-truncate text-wrap d-flex gap-1 fw-bold">
                        <span>
                           {{
                              (cart_item?.product?.offers?.length ?
                              (cart_item?.price - cart_item?.price * cart_item?.product?.offers[0]?.percentage/100)
                              :
                              cart_item?.price)
                              |
                              price_round
                           }}
                        </span>
                        <span>{{ currency }}</span>
                     </div>


                     <div class="badge fs-6 fw-normal ps-0 text-dark">
                        <div
                        class="change-item-amount w-100 d-flex justify-content-between align-items-center bg-whiterounded-3"
                      >
                        <div
                          class="amount-remove border-1 rounded-1 d-flex justify-content-center align-items-center curser-pointer"
                          (click)="updateAmount(cart_item, cart_item.amount - 1,i)"
                        >
                          <ng-container *ngIf="cart_item.amount == 1; else elseTemplate">
                           <p class="m-0 fs-3">-</p>
                        </ng-container>
                          <ng-template #elseTemplate>
                            <p class="m-0 fs-3">-</p>
                          </ng-template>
                        </div>
                        <div class="amount">
                          <p class="m-0 fw-bold">{{ cart_item.amount }}</p>
                        </div>
                        <div
                          class="amount-add p-2 d-flex rounded-1 justify-content-center align-items-center"
                          (click)="updateAmount(cart_item, cart_item.amount + 1, i)"
                        >
                          <i class="text-white fs-5">+</i>
                        </div>
                      </div>
                     </div>

                     <!-- <p [innerHTML]="cart_item.product?.description" class="cart-item-description text-truncate text-wrap"></p> -->


                     <div class="d-flex flex-wrap gap-2 mt-2" *ngIf="cart_item?.cart_product_specification?.length">
                        <span class="badge rounded-pill bg-secondary" *ngFor="let option of cart_item?.cart_product_specification">
                           {{ option?.attribute_options?.attributes_options?.name }}
                        </span>
                     </div>

                     <div class="remove-box mt-2">
                        <button class="bg-transparent align-items-center border-0 d-flex gap-1 kuRZUo sc-27be7f42-13 text-lowercase" (click)="delete_cart_item(cart_item);">
                           <img src="../../../../../assets/icon/trash.svg" alt="remove-item" class="sc-27be7f42-17 gGnnuM">
                           <span class="sc-27be7f42-24 fXAkRJ mb-1">{{ "remove" | translate: "cart" }}</span>
                        </button>
                     </div>

                  </span>


               </div>
            </div>


           <!-- cart placeholder -->
         <div *ngIf="!isLoading && isNotFound" class="d-flex flex-column gap-3 position-relative px-5 start-50 top-50 translate-middle">

            <div class="d-flex justify-content-center">
               <svg class="empty-cart-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 345.77 317.9"><g id="Layer_2" data-name="Layer 2"><g id="Layer_1-2" data-name="Layer 1"><path d="M221,120H328.6c8.85,0,12.24,3.52,11.19,12.16-3.35,27.52-6.85,55-10.28,82.53q-5,40.53-10.06,81c-.54,4.34-1,8.68-1.62,13-.85,6.17-4.11,9.1-10.28,9.1q-137.48,0-274.93,0c-6.3,0-9.45-2.79-10.23-9Q16,257.94,9.63,207,4.93,169.65.18,132.3C-.87,124.15,2.67,120,11,120H119.2v-4.59q-.06-51.18-.13-102.37c0-1.5,0-3,.09-4.49.39-5.26,3.76-8.55,9-8.55Q170,0,211.78,0c5.88,0,9.35,3.82,9.35,10.23,0,17.63-.09,35.25-.11,52.87q0,26.07,0,52.13ZM66,126.16c.31,2.94.54,5.38.84,7.8q5,40.5,10,81c3.88,31.07,7.9,62.13,11.68,93.22.37,3,1.39,3.68,4.16,3.66,16.12-.1,32.25-.05,48.37-.05q82.32,0,164.62,0c3.18,0,5.69-.28,6.17-4.2q3.75-30.84,7.61-61.66,3.57-28.6,7.17-57.2c2.35-18.82,4.76-37.63,7-56.45.67-5.58,0-6.14-5.46-6.14H66ZM179,30.15H161.3v89.56H179ZM40.38,302.51l-.68-.7c0-.25,0-.5-.05-.75Q35.83,270.58,32,240.11q-5.52-44-11-88.09c-.7-5.57-1.29-11.17-2.33-16.68-.24-1.28-2.12-2.24-3.25-3.35a37.84,37.84,0,0,0-2.77,3.82c-.31.55-.05,1.47,0,2.21q4.23,33.82,8.47,67.64l8.7,69.49c1.14,9,2.18,18.1,3.59,27.1.22,1.37,2.22,2.47,3.4,3.69Z"/><path d="M255.82,38.55c0-5.62,0-11.23,0-16.85.06-6,3.55-9.51,9.52-9.68,1.74,0,3.49-.07,5.24,0,5.15.27,8.84,3.56,8.93,8.74q.32,18.15,0,36.31c-.09,5.16-3.79,8.46-8.95,8.73-1.86.1-3.74.09-5.61,0-5.53-.24-9-3.77-9.12-9.31C255.75,50.53,255.82,44.54,255.82,38.55Zm5.93.36c0,5.35,0,10.71,0,16.07,0,4.32.63,4.89,5.05,4.93,1.12,0,2.5.4,3.31-.11,1.37-.85,3.37-2.25,3.4-3.46.25-11.58.17-23.18.13-34.77,0-2.41-1.35-3.63-3.79-3.61-1.25,0-2.5.06-3.74,0-3.23-.18-4.46,1.38-4.4,4.52C261.83,27.94,261.75,33.42,261.75,38.91Z"/><path d="M318.68,95.86c-5.61,0-11.23,0-16.85,0-6.46-.06-9.91-3.54-10-10,0-1.62-.05-3.25,0-4.87.21-5.12,3.59-8.85,8.71-8.92,12.1-.16,24.21,0,36.32,0a7.62,7.62,0,0,1,1.84.25c5.48,1.39,7.67,6.1,6.9,14.73-.47,5.17-3.83,8.62-9,8.76-6,.17-12,0-18,0ZM318.79,78c-5.48,0-11,.1-16.45,0-3.41-.08-4.83,1.38-4.59,4.71.09,1.24,0,2.49,0,3.74,0,2.28,1.19,3.5,3.44,3.51q17.4,0,34.78,0c2.47,0,3.64-1.33,3.7-3.72,0-1.25,0-2.49,0-3.74.13-3.13-1.28-4.56-4.47-4.5C329.76,78,324.28,78,318.79,78Z"/><path d="M343,25.66c-1.17,2.11-2,4.6-3.58,6.28-8.06,8.34-16.29,16.53-24.58,24.66-4.33,4.24-9.13,4.09-13.57-.12-1.08-1-2.15-2.08-3.17-3.17-4.18-4.45-4.25-9.21,0-13.55q12.11-12.25,24.36-24.35c4.45-4.39,9.29-4.34,13.81.08C339.08,18.25,342.51,20.7,343,25.66Zm-35.4,28.68a30.33,30.33,0,0,0,3.77-2.65q11.57-11.44,23-23c2.95-3,2.79-4-.89-7.64s-4.54-3.78-7.6-.74c-7.52,7.47-15.06,14.93-22.44,22.53-1.15,1.18-2.61,3.74-2.12,4.55C302.88,49.93,305.31,51.94,307.57,54.34Z"/><path d="M155.37,219c0,14,.08,28,0,42a15.07,15.07,0,0,1-10.87,14.58c-6.12,1.93-13.07,0-16.54-5.57a20.42,20.42,0,0,1-3.11-10.13c-.25-27.25-.11-54.5-.15-81.74,0-13.71,13.09-19.56,22.23-14.74,5.74,3,8.46,7.93,8.48,14.35Q155.42,198.34,155.37,219Zm-24.32-.08h0c0,14-.07,28,0,42a8.78,8.78,0,0,0,8.56,9.11c4.78.2,8.74-3.32,9.37-8.38a31.2,31.2,0,0,0,.1-3.75q0-30.74,0-61.49c0-6.24.08-12.5,0-18.74-.11-5.22-3.21-8.9-7.77-9.59-5.61-.85-10.22,3.35-10.26,9.61C131,191.39,131.05,205.13,131.05,218.88Z"/><path d="M215.4,219.14c0,13.88.06,27.75,0,41.62a15.17,15.17,0,0,1-10.7,14.73c-6.1,2-13.07.12-16.61-5.37A20,20,0,0,1,184.85,260c-.26-27.37-.17-54.74-.13-82.12,0-6.52,2.65-11.67,8.66-14.62a14.44,14.44,0,0,1,15.29,1.12c4.7,3.2,6.74,7.85,6.74,13.48Q215.38,198.52,215.4,219.14ZM191.07,219h0c0,14-.07,28,0,42a8.78,8.78,0,0,0,8.65,9,9.11,9.11,0,0,0,9.23-8.12,25.83,25.83,0,0,0,.14-3.74q0-39.18,0-78.36a20.1,20.1,0,0,0-.71-5.9A8.77,8.77,0,0,0,199,168a8.87,8.87,0,0,0-7.83,7.86,37.72,37.72,0,0,0-.11,4.12Q191.07,199.48,191.07,219Z"/><path d="M275.42,218.86c0,14,.08,28,0,42a15.26,15.26,0,0,1-29.84,4.62,21.84,21.84,0,0,1-.8-5.92q-.06-40.68,0-81.37a20.64,20.64,0,0,1,.86-5.9,15.24,15.24,0,0,1,29.77,4.58C275.51,190.87,275.42,204.87,275.42,218.86Zm-6.23.4c0-13.25,0-26.5,0-39.74a19.93,19.93,0,0,0-.57-5.18,8.79,8.79,0,0,0-9.43-6.35,8.89,8.89,0,0,0-8,8.13,29.77,29.77,0,0,0-.09,3q0,39.93,0,79.87a23.49,23.49,0,0,0,.14,3.36,8.87,8.87,0,0,0,12.11,7c4.43-1.82,5.86-5.45,5.85-9.94Q269.17,239.33,269.19,219.26Z"/><path d="M327,137.45q-2.44,19.7-4.9,39.38-4,31.75-7.94,63.51c-2.55,20.42-5,40.86-7.72,61.27-.2,1.46-2,3.81-3.1,3.83-2.69,0-2.64-2.54-2.4-4.54,1.29-10.78,2.66-21.54,4-32.31l7.92-63.14q4-31.74,8-63.5a33.16,33.16,0,0,1,.94-6.27c.44-1.3,1.83-2.27,2.79-3.39.81,1.34,1.65,2.67,2.41,4.05C327.15,136.62,327,137.07,327,137.45Z"/></g></g></svg>
            </div>

            <div class="text-center">
               <p class="fs-6 fw-bold text-uppercase empty-cart-title">{{ "cart_empty" | translate: "cart" }}</p>
            </div>

         </div>

      </div>



        <div class="d-flex flex-column mb-3"  >
           <!-- total -->
           <div class="mt-4 cart-total d-flex px-3">
              <span>{{ "total" | translate: "cart"  }}:</span>
              <div class="me-2 ms-2">
                 <span>{{ cart_total | price_round }}</span>
                 <span>{{ currency }} </span>
              </div>
           </div>


           <!-- controls -->
           <div class="action-butns d-flex gap-2 mt-2 px-3">
              <button nz-button nzType="primary" class="btn-close-white px-3 py-2 rounded col" *ngIf="!isNotFound"  (click)="redirect();">
                 <a class="text-decoration-none">{{ "checkout" | translate: "cart" }}</a>
              </button>
              <button class="col  px-3 py-2 rounded continue-shopping-btn" nz-button nzType="primary"  nzGhost (click)="hideCart()">
                <a class="text-decoration-none text-dark"> {{ "continue_shopping" | translate: "cart" }}</a>
              </button>
           </div>
        </div>



     </div>



  </div>



</div>
